module.exports = __webpack_public_path__ + "img/mg.5ef4c90b.svg";